import heroImg from "../../assets/hero_new.png";
import heroMobileImg from "../../assets/hero_mobile.png";

export default function HeroSection() {
  return (
    <section className="w-full bg-[#00499d] md:h-[676px] relative">
      {/* Mobile background image - centered both vertically and horizontally */}
      <div
        className="absolute inset-0 md:hidden opacity-30"
        style={{
          backgroundImage: `url(${heroMobileImg})`,
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}
      />
      <div className="absolute inset-0 md:hidden bg-gradient-to-b from-[#00499d]/80 via-[#00499d]/70 to-[#00499d]/90" />

      <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-center h-full px-4 md:px-0 py-10 md:py-0 relative z-10">
        <div className="text-white">
          <h1 className="font-medium text-[36px] leading-[40px] md:text-[80px] md:leading-[84px] lg:text-[124px] lg:leading-[104px] tracking-[-3%]">
            Rebuilding Ontario's Promise
          </h1>
          <p className="mt-4 md:mt-6 text-[14px] md:text-[18px] lg:text-[20px] text-white/90 max-w-xl leading-relaxed">
            Ontario's promise was built on conservative principles of personal responsibility, strong families, and good government, underpinned by a strong free-market economy. When those principles are lost, the province drifts. Project Ontario is bringing them back with ideas and leadership to put Ontario on the right track again.
          </p>
        </div>
        <div className="w-full h-full hidden md:flex items-center justify-center">
          <img src={heroImg} alt="Project Ontario" className="h-full w-auto object-contain" />
        </div>
      </div>
    </section>
  );
}

